module.exports = __webpack_public_path__ + "img/1534441117.0759590a.jpg";